var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaypal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 52",
    width: 52,
    height: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009cde",
    d: "M40.892 15.2c.6-3.4 0-5.8-1.9-7.9-1.9-2.3-5.6-3.3-10.4-3.3h-13.5c-1 0-1.8.7-2 1.7l-5.7 36.1c-.1.7.4 1.3 1.1 1.3h8.4l-.6 3.7c-.1.7.4 1.2 1 1.2h7.1c.9 0 1.6-.7 1.7-1.4l.1-.3 1.3-8.4.1-.4c.1-.8.9-1.4 1.7-1.4h1.1c6.9 0 12.3-2.8 13.9-10.9.7-3.3.3-6.2-1.4-8.2-.5-.9-1.2-1.4-2-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M40.892 15.2c.6-3.4 0-5.8-1.9-7.9-1.9-2.3-5.6-3.3-10.4-3.3h-13.5c-1 0-1.8.7-2 1.7l-5.7 36.1c-.1.7.4 1.3 1.1 1.3h8.4l2.1-13.4-.1.4c.2-1 1.1-1.7 2-1.7h4c7.9 0 14-3.2 15.9-12.4 0-.3.1-.6.1-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003087",
    d: "M21.392 15.2c.1-.6.4-1 1-1.3.2-.1.4-.2.8-.2h10.7l3.6.3c.3 0 .6.1.9.2s.6.1.9.2c.1 0 .2.1.4.1.6.2 1 .3 1.4.7.6-3.4 0-5.8-1.9-7.9-2-2.3-5.7-3.3-10.5-3.3h-13.6c-1 0-1.8.7-2 1.7l-5.7 36.1c-.1.7.4 1.3 1.1 1.3h8.4l4.5-27.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.60efd7f68147b169f75eb26d90f139c7.svg";
export { ForwardRef as ReactComponent };